"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _formik = require("formik");

var _DateInput = _interopRequireDefault(require("../DateInput"));

var S = _interopRequireWildcard(require("../DateInput/styled"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var dateBoundaries = function dateBoundaries(date) {
  return {
    start: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0),
    end: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)
  };
};

var DateRange = function DateRange(_ref) {
  var fromName = _ref.fromName,
      toName = _ref.toName,
      _ref$fromLabel = _ref.fromLabel,
      fromLabel = _ref$fromLabel === void 0 ? '' : _ref$fromLabel,
      _ref$toLabel = _ref.toLabel,
      toLabel = _ref$toLabel === void 0 ? '' : _ref$toLabel,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/_react["default"].createElement(S.DatePickerInput, {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement(S.DatePickerContainer, {
    className: "form-row"
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: fromName
  }, function (_ref2) {
    var form = _ref2.form;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-md-6"
    }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
      name: fromName,
      label: fromLabel,
      selectsStart: true,
      startDate: form.values[fromName],
      endDate: form.values[toName],
      maxDate: form.values[toName],
      setTime: function setTime(date) {
        return dateBoundaries(date).start;
      },
      rawDate: true,
      required: required
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-12 col-md-6"
    }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
      name: toName,
      label: toLabel,
      selectsEnd: true,
      startDate: form.values[fromName],
      endDate: form.values[toName],
      minDate: form.values[fromName],
      setTime: function setTime(date) {
        return dateBoundaries(date).end;
      },
      rawDate: true,
      required: required
    })));
  })));
};

DateRange.displayName = 'DateRange';
DateRange.propTypes = {
  fromName: _propTypes["default"].string.isRequired,
  toName: _propTypes["default"].string.isRequired,
  fromLabel: _propTypes["default"].string,
  toLabel: _propTypes["default"].string,
  help: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  placeholder: _propTypes["default"].string,
  className: _propTypes["default"].string,
  show: _propTypes["default"].string,
  prefix: _propTypes["default"].string
};
var _default = DateRange;
exports["default"] = _default;